import { differenceInCalendarDays } from 'date-fns';
import { format } from 'date-fns-tz';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { OrderShort } from '~/api/Order';
import { company } from '~/company/Company';
import { DATE_FORMAT } from '~/components/ActiveOrderCard/constants';
import { useDateLang } from '~/hooks/useDateLang';
import { useTimeFormat } from '~/hooks/useTimeFormat';

export const useEstimatedTime = (
  order?: OrderShort,
  opts?: { todayAtLabel?: string; deliveryTimeLabel?: string },
) => {
  const {
    todayAtLabel = 'phrases:todayAt',
    deliveryTimeLabel = 'phrases:deliveryTime',
  } = opts || {};

  const { locale } = useDateLang();
  const { t } = useTranslation();
  const { timeFormat } = useTimeFormat();

  return useMemo(() => {
    if (!order) {
      return '';
    }

    const estimationDateMin = new Date(order.sla.deliver_by_min);
    const estimationDateMax = new Date(order.sla.deliver_by_max);
    const difference = differenceInCalendarDays(estimationDateMin, new Date());

    if (!difference) {
      return t(todayAtLabel, {
        timeMin: format(estimationDateMin, timeFormat, {
          timeZone: company.config.timeZone,
          locale,
        }),
        timeMax: format(estimationDateMax, timeFormat, {
          timeZone: company.config.timeZone,
          locale,
        }),
      });
    }

    return t(deliveryTimeLabel, {
      date: format(estimationDateMin, DATE_FORMAT, {
        timeZone: company.config.timeZone,
        locale,
      }),
      timeMin: format(estimationDateMin, timeFormat, {
        timeZone: company.config.timeZone,
        locale,
      }),
      timeMax: format(estimationDateMax, timeFormat, {
        timeZone: company.config.timeZone,
        locale,
      }),
    });
  }, [order, t, locale]);
};
